import { useState } from "react";
import { CommingSoon } from "../assets/images";
import Button from "./Button";
import { LeftArrowIcon, RightArrowIcon } from "../utils/icon.utils";
import Skeleton from "react-loading-skeleton";

export default function PhotoGallery({ data }) {
  const images = data?.length ? data : [CommingSoon];

  const imageLength = images.length;

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };
  return (
    <div>
      <img
        className="img-fluid border rounded"
        src={images[currentImageIndex]}
        alt={`Car ${currentImageIndex + 1}`}
      />
      <div className="d-flex align-items-center justify-content-between mt-3">
        <p className="m-0" style={{ fontSize: "0.8rem", fontWeight: 700 }}>
          {currentImageIndex + 1} / {imageLength}
        </p>
        <div className="d-flex justify-content-end gap-3">
          <Button onClick={prevImage} name="Previous" icon={LeftArrowIcon} />
          <Button onClick={nextImage} name="Next" icon={RightArrowIcon} />
        </div>
      </div>
    </div>
  );
}

// PhotoGallery skeleton
export function PhotoGallerySkeleton() {
  return (
    <div className="w-100">
      <div>
        <Skeleton width={`100%`} height={300} />
      </div>{" "}
      {/* image*/}
      <div className="d-flex align-items-center justify-content-between mt-3">
        <p className="w-100 m-0" style={{ fontSize: "0.8rem", fontWeight: 700 }}>
          <Skeleton width={`100%`} height={20} />
        </p>
      </div>
    </div>
  );
}
